import { render, staticRenderFns } from "./CompanyMembersList.vue?vue&type=template&id=363b8d58&scoped=true&"
import script from "./CompanyMembersList.vue?vue&type=script&lang=js&"
export * from "./CompanyMembersList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMembersList.vue?vue&type=style&index=0&id=363b8d58&lang=scss&scoped=true&"
import style1 from "./CompanyMembersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b8d58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VMenu,VTooltip})
